module.exports = __webpack_public_path__ + "img/icon-migration-member-green.121f5ed8.svg";